const StringToColourDirective = function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var options = {
                styleAttr: "background-color"
            }

            if (attrs.styleAttribute)
                options.styleAttr = attrs.styleAttribute;

            scope.$watch(attrs.stringToColour, function (val) {
                if (val) {
                    element.css("{0}".format(options.styleAttr), stringToColour(val));
                }
            });


            var stringToColour = function (str) {
                var hash = 0;
                for (var i = 0; i < str.length; i++) {
                    hash = str.charCodeAt(i) + ((hash << 5) - hash);
                }
                var colour = '#';
                for (var i = 0; i < 3; i++) {
                    var value = (hash >> (i * 8)) & 0xFF;
                    colour += ('00' + value.toString(16)).substr(-2);
                }
                return colour;
            };
        }
    };
};

export { StringToColourDirective };